export default __webpack_public_path__ + "static/media/app-app-store.9040bd4f.svg";